import React, { useState, useEffect } from 'react';

/**
 * Composant OfflineBanner - Affiche un banner quand l'utilisateur est hors ligne
 */
const OfflineBanner = () => {
  const [isOnline, setIsOnline] = useState(navigator.onLine);
  const [showBanner, setShowBanner] = useState(!navigator.onLine);
  const [wasOffline, setWasOffline] = useState(false);

  useEffect(() => {
    const handleOnline = () => {
      console.log('[PWA] Connexion rétablie');
      setIsOnline(true);
      setWasOffline(true);
      
      // Afficher un message de succès pendant 3 secondes
      setShowBanner(true);
      setTimeout(() => {
        setShowBanner(false);
        setWasOffline(false);
      }, 3000);
    };

    const handleOffline = () => {
      console.log('[PWA] Connexion perdue');
      setIsOnline(false);
      setShowBanner(true);
      setWasOffline(false);
    };

    window.addEventListener('online', handleOnline);
    window.addEventListener('offline', handleOffline);

    return () => {
      window.removeEventListener('online', handleOnline);
      window.removeEventListener('offline', handleOffline);
    };
  }, []);

  if (!showBanner) {
    return null;
  }

  if (wasOffline && isOnline) {
    // Banner de reconnexion (vert)
    return (
      <div className="fixed top-0 left-0 right-0 z-50 animate-slide-down">
        <div className="bg-green-600 text-white px-4 py-3 shadow-lg">
          <div className="max-w-7xl mx-auto flex items-center justify-between gap-4">
            <div className="flex items-center gap-3">
              <span className="text-2xl">✅</span>
              <div>
                <p className="font-semibold">Connexion rétablie</p>
                <p className="text-sm text-green-100">Vous êtes de nouveau en ligne</p>
              </div>
            </div>
            <button
              onClick={() => setShowBanner(false)}
              className="text-white hover:text-green-100 transition-colors"
              aria-label="Fermer"
            >
              <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
                <path fillRule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clipRule="evenodd" />
              </svg>
            </button>
          </div>
        </div>
      </div>
    );
  }

  // Banner hors ligne (orange/rouge)
  return (
    <div className="fixed top-0 left-0 right-0 z-50 animate-slide-down">
      <div className="bg-orange-600 text-white px-4 py-3 shadow-lg">
        <div className="max-w-7xl mx-auto flex items-center justify-between gap-4">
          <div className="flex items-center gap-3">
            <div className="relative">
              <span className="text-2xl">📡</span>
              <span className="absolute top-0 right-0 w-2 h-2 bg-red-500 rounded-full animate-ping"></span>
            </div>
            <div>
              <p className="font-semibold">Mode hors ligne</p>
              <p className="text-sm text-orange-100">
                Certaines fonctionnalités peuvent être limitées
              </p>
            </div>
          </div>
          <button
            onClick={() => window.location.reload()}
            className="px-4 py-2 bg-white text-orange-600 rounded-lg text-sm font-medium hover:bg-orange-50 transition-colors"
          >
            Réessayer
          </button>
        </div>
      </div>

      <style jsx>{`
        @keyframes slide-down {
          from {
            transform: translateY(-100%);
            opacity: 0;
          }
          to {
            transform: translateY(0);
            opacity: 1;
          }
        }
        .animate-slide-down {
          animation: slide-down 0.3s ease-out;
        }
      `}</style>
    </div>
  );
};

export default OfflineBanner;
